export default __webpack_public_path__ + "static/media/Home-foto-header-sports-Tower-viajes-desk.86b1eadd.jpg";